import React from 'react';
import { ChannelSelectorProvider } from '../../context/ChannelSelectorState';
import { ChannelDataStateProvider } from '../../context/ChannelDataStateProvider';
import ChannelSelectorPage from './ChannelSelectorPage';
const SupportChannelSelectorMain = () => React.createElement(ChannelDataStateProvider, null,
    React.createElement(ChannelSelectorProvider, null,
        React.createElement(ChannelSelectorPage, null)));
export default SupportChannelSelectorMain;
